:host{
    display: block;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 1rem;
    margin: 1rem 0px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 4px 2px;
}
h1 {
    margin: 0;
    padding: 0;
    text-align: center;
}
dnn-tabs{
    /* The color of the inactive tabs. */
    --color-background: lightgray;
    /* outline color when hovering or pre-selecting a tab. */
    --color-focus: var(--dnn-color-secondary, #8cacba);
    /* The color of the text for inactive tabs. */
    --color-text: black;
    /* The color of the active tab. */
    --color-visible: var(--dnn-color-secondary, #8cacba);
    /* The color of the text for the active tab. */
    --color-visible-text: black;
}